import React, {
    useEffect,
    useState
} from 'react';
import './adminAccount.css';
import API_BASE_URL from '../../../config/api';

const AdminAccount = () => {
    const [accountForm, setAccountForm] =
        useState({
            adminId: '',
            adminName: '',
            currentPassword: ''
        });

    const [passwordForm, setPasswordForm] =
        useState({
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
        });

    const [isLoading, setIsLoading] =
        useState(true);

    const [
        isAccountSubmitting,
        setIsAccountSubmitting
    ] = useState(false);

    const [
        isPasswordSubmitting,
        setIsPasswordSubmitting
    ] = useState(false);

    /*
     * ================================================
     * ADMIN INFO
     * ================================================
     */

    useEffect(() => {
        const fetchAdmin = async () => {
            try {
                setIsLoading(true);

                const response = await fetch(
                    `${API_BASE_URL}/api/admin/me`,
                    {
                        method: 'GET',
                        credentials: 'include'
                    }
                );

                const result =
                    await response.json();

                if (!response.ok) {
                    throw new Error(
                        result.message ||
                        '관리자 정보를 불러오지 못했습니다.'
                    );
                }

                const admin =
                    result.admin;

                setAccountForm({
                    adminId:
                        admin.admin_id || '',
                    adminName:
                        admin.admin_name || '',
                    currentPassword: ''
                });
            } catch (error) {
                console.error(
                    '관리자 정보 조회 오류:',
                    error
                );
            } finally {
                setIsLoading(false);
            }
        };

        fetchAdmin();
    }, []);

    /*
     * ================================================
     * ACCOUNT CHANGE
     * ================================================
     */

    const handleAccountChange = (
        event
    ) => {
        const {
            name,
            value
        } = event.target;

        setAccountForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    /*
     * ================================================
     * PASSWORD CHANGE
     * ================================================
     */

    const handlePasswordChange = (
        event
    ) => {
        const {
            name,
            value
        } = event.target;

        setPasswordForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    /*
     * ================================================
     * ACCOUNT SUBMIT
     * ================================================
     */

    const handleAccountSubmit = async (
        event
    ) => {
        event.preventDefault();

        if (
            !accountForm.adminId.trim()
        ) {
            alert(
                '관리자 아이디를 입력해주세요.'
            );

            return;
        }

        if (
            !accountForm.adminName.trim()
        ) {
            alert(
                '관리자 이름을 입력해주세요.'
            );

            return;
        }

        if (
            !accountForm.currentPassword
        ) {
            alert(
                '현재 비밀번호를 입력해주세요.'
            );

            return;
        }

        try {
            setIsAccountSubmitting(
                true
            );

            const response = await fetch(
                `${API_BASE_URL}/api/admin/account`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type':
                            'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        adminId:
                            accountForm.adminId,
                        adminName:
                            accountForm.adminName,
                        currentPassword:
                            accountForm.currentPassword
                    })
                }
            );

            const result =
                await response.json();

            if (!response.ok) {
                throw new Error(
                    result.message ||
                    '계정 정보 수정에 실패했습니다.'
                );
            }

            setAccountForm(
                (prev) => ({
                    ...prev,
                    adminId:
                        result.admin.admin_id,
                    adminName:
                        result.admin.admin_name,
                    currentPassword: ''
                })
            );

            alert(
                '계정 정보가 수정되었습니다.'
            );
        } catch (error) {
            console.error(
                '계정 정보 수정 오류:',
                error
            );

            alert(
                error.message
            );
        } finally {
            setIsAccountSubmitting(
                false
            );
        }
    };

    /*
     * ================================================
     * PASSWORD SUBMIT
     * ================================================
     */

    const handlePasswordSubmit = async (
        event
    ) => {
        event.preventDefault();

        if (
            !passwordForm.currentPassword
        ) {
            alert(
                '현재 비밀번호를 입력해주세요.'
            );

            return;
        }

        if (
            passwordForm.newPassword.length <
            8
        ) {
            alert(
                '새 비밀번호는 8자 이상 입력해주세요.'
            );

            return;
        }

        if (
            passwordForm.newPassword !==
            passwordForm.confirmPassword
        ) {
            alert(
                '새 비밀번호 확인이 일치하지 않습니다.'
            );

            return;
        }

        try {
            setIsPasswordSubmitting(
                true
            );

            const response = await fetch(
                `${API_BASE_URL}/api/admin/password`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type':
                            'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        currentPassword:
                            passwordForm.currentPassword,
                        newPassword:
                            passwordForm.newPassword
                    })
                }
            );

            const result =
                await response.json();

            if (!response.ok) {
                throw new Error(
                    result.message ||
                    '비밀번호 변경에 실패했습니다.'
                );
            }

            setPasswordForm({
                currentPassword: '',
                newPassword: '',
                confirmPassword: ''
            });

            alert(
                '비밀번호가 변경되었습니다.'
            );
        } catch (error) {
            console.error(
                '비밀번호 변경 오류:',
                error
            );

            alert(
                error.message
            );
        } finally {
            setIsPasswordSubmitting(
                false
            );
        }
    };

    if (isLoading) {
        return (
            <div className="admin-account">

                <div className="admin-account-loading">

                    <i className="mdi mdi-loading mdi-spin"></i>

                    <strong>
                        계정 정보를 불러오는 중입니다.
                    </strong>

                </div>

            </div>
        );
    }

    return (
        <div className="admin-account">

            {/* HEADER */}
            <div className="admin-account-header">

                <p>
                    ACCOUNT
                </p>

                <h1>
                    계정 설정
                </h1>

                <span>
                    관리자 계정 정보와 비밀번호를 변경합니다.
                </span>

            </div>

            {/* ACCOUNT */}
            <form
                className="admin-account-section"
                onSubmit={
                    handleAccountSubmit
                }
            >

                <div className="admin-account-section-heading">

                    <h2>
                        계정 정보
                    </h2>

                    <p>
                        관리자 로그인 정보와 표시 이름을 변경할 수 있습니다.
                    </p>

                </div>

                <div className="admin-account-grid">

                    <div className="admin-account-group">

                        <label htmlFor="adminId">
                            관리자 ID
                        </label>

                        <input
                            id="adminId"
                            type="text"
                            name="adminId"
                            value={
                                accountForm.adminId
                            }
                            onChange={
                                handleAccountChange
                            }
                        />

                    </div>

                    <div className="admin-account-group">

                        <label htmlFor="adminName">
                            관리자 이름
                        </label>

                        <input
                            id="adminName"
                            type="text"
                            name="adminName"
                            value={
                                accountForm.adminName
                            }
                            onChange={
                                handleAccountChange
                            }
                        />

                    </div>

                    <div className="admin-account-group full">

                        <label htmlFor="accountCurrentPassword">
                            현재 비밀번호
                        </label>

                        <input
                            id="accountCurrentPassword"
                            type="password"
                            name="currentPassword"
                            value={
                                accountForm.currentPassword
                            }
                            onChange={
                                handleAccountChange
                            }
                            autoComplete="current-password"
                            placeholder="변경사항 저장을 위해 현재 비밀번호를 입력해주세요."
                        />

                    </div>

                </div>

                <div className="admin-account-actions">

                    <button
                        type="submit"
                        disabled={
                            isAccountSubmitting
                        }
                    >
                        {isAccountSubmitting
                            ? '저장 중...'
                            : '계정 정보 저장'
                        }
                    </button>

                </div>

            </form>

            {/* PASSWORD */}
            <form
                className="admin-account-section"
                onSubmit={
                    handlePasswordSubmit
                }
            >

                <div className="admin-account-section-heading">

                    <h2>
                        비밀번호 변경
                    </h2>

                    <p>
                        보안을 위해 현재 비밀번호 확인 후 새 비밀번호로 변경합니다.
                    </p>

                </div>

                <div className="admin-account-grid">

                    <div className="admin-account-group full">

                        <label htmlFor="passwordCurrentPassword">
                            현재 비밀번호
                        </label>

                        <input
                            id="passwordCurrentPassword"
                            type="password"
                            name="currentPassword"
                            value={
                                passwordForm.currentPassword
                            }
                            onChange={
                                handlePasswordChange
                            }
                            autoComplete="current-password"
                            placeholder="현재 비밀번호"
                        />

                    </div>

                    <div className="admin-account-group">

                        <label htmlFor="newPassword">
                            새 비밀번호
                        </label>

                        <input
                            id="newPassword"
                            type="password"
                            name="newPassword"
                            value={
                                passwordForm.newPassword
                            }
                            onChange={
                                handlePasswordChange
                            }
                            autoComplete="new-password"
                            placeholder="8자 이상"
                        />

                    </div>

                    <div className="admin-account-group">

                        <label htmlFor="confirmPassword">
                            새 비밀번호 확인
                        </label>

                        <input
                            id="confirmPassword"
                            type="password"
                            name="confirmPassword"
                            value={
                                passwordForm.confirmPassword
                            }
                            onChange={
                                handlePasswordChange
                            }
                            autoComplete="new-password"
                            placeholder="새 비밀번호를 다시 입력해주세요."
                        />

                    </div>

                </div>

                <div className="admin-account-actions">

                    <button
                        type="submit"
                        disabled={
                            isPasswordSubmitting
                        }
                    >
                        {isPasswordSubmitting
                            ? '변경 중...'
                            : '비밀번호 변경'
                        }
                    </button>

                </div>

            </form>

        </div>
    );
};

export default AdminAccount;